// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.denominations-input::placeholder{
    font-size: 14px;
}

.denominations-input{
    height: 20px;
    width: 130px;
    outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.inputfile{
    width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile + label {
    font-size: 16px;
    color: white;
    font-family: "Roboto";
    background-color:  #0b54ab;
    display: inline-block;
    padding: 0.5rem 1rem;
    border: 1px solid  #0b54ab;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
      box-shadow 0.2s;
    border-radius: 3px;
}
.inputfile + label {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/modals/offlinePaymentModal/index.css"],"names":[],"mappings":"AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,YAAY;EACd,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B;qBACiB;IACjB,kBAAkB;AACtB;AACA;EACE,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.denominations-input::placeholder{\n    font-size: 14px;\n}\n\n.denominations-input{\n    height: 20px;\n    width: 130px;\n    outline: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.inputfile{\n    width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.inputfile + label {\n    font-size: 16px;\n    color: white;\n    font-family: \"Roboto\";\n    background-color:  #0b54ab;\n    display: inline-block;\n    padding: 0.5rem 1rem;\n    border: 1px solid  #0b54ab;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s,\n      box-shadow 0.2s;\n    border-radius: 3px;\n}\n.inputfile + label {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
